<div class="search-container-filter">
  <div class="search-input-wrapper">
    <span class="search-icon">
      <i class="material-icons">{{ icon }}</i>
    </span>
    <input #searchInput type="text" [placeholder]="placeholder" (input)="onInput($event)" />
  </div>
</div>